export enum AlertPressureType {
  peakAllFoot = 1,
  peakFrontFoot = 2,
  constant15min = 3,
  constant30min = 4,
  constant45min = 5,
  constant60min = 6,
}
